import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LocationsModule } from '../../locations/locations.module';
import { WsgSharedModule } from '@morningstar/wsg/shared';
import { DefaultLocationDialogComponent } from './default-location-dialog.component';
import { ClientAutocompleteModule } from '../../autocomplete/client/client-autocomplete.module';

@NgModule({
  declarations: [
    DefaultLocationDialogComponent
  ],
  imports: [
    CommonModule,
    WsgSharedModule,
    LocationsModule,
    ClientAutocompleteModule
  ],
  exports: [
    DefaultLocationDialogComponent
  ]
})
export class DefaultLocationDialogModule { }
